/* eslint-disable @typescript-eslint/no-magic-numbers */
import { ReactElement, useEffect, useMemo } from 'react';

interface SnackBarProperties {
  text: string;
  onClick?: () => void;
  onClose?: () => void;
  variant: string;
}

function SnackBar({ text, onClick, onClose, variant }: SnackBarProperties): ReactElement {
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onClose) onClose();
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const iconUrl = useMemo(() => {
    if (variant === 'warning') {
      return './icons/warning-icon.svg';
    }
    if (variant === 'success') {
      return './icons/correct-icon.svg';
    }

    return './icons/error-icon.svg';
  }, [variant]);

  const textClass = useMemo(() => {
    if (variant === 'warning') {
      return 'text-primary-yellow-4';
    }
    if (variant === 'success') {
      return 'text-success-green-4';
    }

    return 'text-error-red-3';
  }, [variant]);

  const buttonClass = useMemo(() => {
    if (variant === 'warning') {
      return 'border-primary-yellow-4 bg-primary-yellow-1';
    }
    if (variant === 'success') {
      return ' border-success-green-4 bg-success-green-1';
    }

    return 'border-error-red-3 bg-error-red-1';
  }, [variant]);

  return (
    <button
      type="button"
      onClick={onClick}
      className={`fixed bottom-4 left-1/2 z-topmost mt-2 flex -translate-x-1/2 transform items-center rounded-[14px] border-4 py-[17px] pl-[27px] pr-[39px] ${buttonClass}`}
    >
      <img src={iconUrl} alt="error icon" className="h-[25px] w-[25px]" />
      <span className={`ml-8 text-[1.25em] font-medium ${textClass}`}>{text}</span>
    </button>
  );
}

SnackBar.defaultProps = {
  onClick: () => {},
  onClose: () => {},
};

export default SnackBar;
